import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  private confirmationHandler = new BehaviorSubject<{ message: string; handler: () => boolean } | null>(null);

  setConfirmation(message: string, handler: () => boolean) {
    this.confirmationHandler.next({ message, handler });
  }

  clearConfirmation() {
    this.confirmationHandler.next(null);
  }

  getConfirmation(): Observable<{ message: string; handler: () => boolean } | null> {
    return this.confirmationHandler.asObservable();
  }
}
